export class Prerender {
	public static readonly instance = new Prerender();

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	private constructor() {
	}

	public setPrerenderReady(): void {
		if (!this.canUpdatePrerender()) {
			return;
		}

		window.prerenderReady = true;
	}

	public get prerenderReady(): boolean {
		return window.prerenderReady;
	}

	private canUpdatePrerender(): boolean {
		return window.prerenderReady === false || window.prerenderReady === undefined;
	}
}
